export default __webpack_public_path__ + "static/media/pdf_icon.0bba5b35.svg";